__turbopack_context__.v({
  "className": "open_sans_8354bc97-module__uAVuSq__className",
  "variable": "open_sans_8354bc97-module__uAVuSq__variable",
});
